/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class EmployeeFilterController {
    public static $inject = [
        '$state',
        'Employee',
        'bsLoadingOverlayService',
        '$uibModalInstance',
        'User',
        'Orgs'
    ];

    public availableFilters;
    public selectedFilterKey = 'nationality';
    public extraFilters;

    constructor(private $state: ng.ui.IStateService,
                private Employee: IEmpService,
                private bsLoadingOverlayService: IBsLoadingService,
                private $uibModalInstance: any,
                private User: IUserService,
                private Orgs: IOrgsService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        if (!this.User.getCurrentUser().userData.user.is_superuser) {
            this.extraFilters = angular.copy(Employee.getFilters());
            this.availableFilters = Employee.getAvailableFilters();
            // get org filters for benefirts and offices
            this.Orgs.getMyOrg().then((response) => {
                if (response.extra) {
                    // if the org has benefits and there is is at least one
                    if (response.extra.benefits && response.extra.benefits.length > 0) {
                        this.availableFilters.benefits.options = [];
                        response.extra.benefits.forEach((category) => {
                            this.availableFilters.benefits.options.push({ value: category.name, name: category.name });
                        });
                    }
                    // if the org has an office structure and there is at least one
                    if (response.extra.offices && response.extra.offices.length > 0) {
                        this.availableFilters.business_licence.options = [];
                        response.extra.offices.forEach((office) => {
                            if ((office['business_licences'] || []).length > 0) {
                                office['business_licences'].forEach((licensee) => {
                                    this.availableFilters.business_licence.options.push({ value: licensee.name, name: licensee.name });
                                });
                            }
                        });
                        this.availableFilters.business_licence.options = _.uniqBy(this.availableFilters.business_licence.options, 'name');
                    }
                }
            });
        }
    }

    public selectFilter(key: string): void {
        this.selectedFilterKey = key;
    }

    public applyFilter(): void {
        this.$state.go('root.employees');
        this.Employee.setFilters(this.extraFilters);
        this.Employee.list();
        this.$uibModalInstance.close();
    }

    public clearFilter(): void {
        let type: string = this.availableFilters[this.selectedFilterKey].type;
        switch (type) {
            case 'date_range': {
                delete this.extraFilters.birth_date__lte;
                delete this.extraFilters.birth_date__gte;
                break;
            } 
            default: {
                delete this.extraFilters[this.selectedFilterKey];
                break;
            }
        }
    }

    public dismiss(): void {
        this.$uibModalInstance.dismiss();
    }
}

angular.module('beneple.employees')
    .controller('EmployeeFilterController', EmployeeFilterController);



// WEBPACK FOOTER //
// ./frontend/scripts/employee/controllers/employee-filter.controller.ts